const ANONYMOUS_FEEDBACK_ID_KEY = "venaqqi_feedback_anonymous_id_v1";

export const getAnonymousFeedbackId = () => {
  try {
    const existing = localStorage.getItem(ANONYMOUS_FEEDBACK_ID_KEY);
    if (existing) return existing;
    const created = window.crypto?.randomUUID?.() || `guest-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(ANONYMOUS_FEEDBACK_ID_KEY, created);
    return created;
  } catch { return `guest-${Date.now()}-${Math.random().toString(36).slice(2)}`; }
};
